function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { LANG_DEFAULT, RESOLUTION_AUTO } from "@common/constants";
import { USER_GET_PROFILE_SETTINGS, USER_SET_PROFILE_SETTINGS } from "@common/constants/action-types";
export var INITIAL_STATE = {
    web_settings: {
        filterTypeRecorded: false,
        filterTypeLive: true,
        isVerticalLayout: true,
        resolution: RESOLUTION_AUTO,
        subtitles: LANG_DEFAULT,
        audio: LANG_DEFAULT,
        DeviceSettingsItemList: [],
        lockPeriod: 5 * 60 * 1000,
        timeToLockChannels: null
    }
};
export default function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : INITIAL_STATE, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case USER_GET_PROFILE_SETTINGS:
            return _object_spread_props(_object_spread({}, state, action.payload), {
                web_settings: _object_spread({}, state.web_settings, action.payload.web_settings)
            });
        case USER_SET_PROFILE_SETTINGS:
            return _object_spread({}, state, action.payload);
        default:
            return state;
    }
}
